import { render, staticRenderFns } from "./ConfigSignature.vue?vue&type=template&id=f063007a&"
import script from "./ConfigSignature.vue?vue&type=script&lang=js&"
export * from "./ConfigSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports